import React, { useState, useEffect } from 'react';
import './AmazonAd.css';

const ASSOCIATE_TAG = 'buks05-20';

// Curated list of classic books on Amazon
const AMAZON_PRODUCTS = [
  {
    asin: '0143105426',
    title: 'Don Quixote',
    author: 'Miguel de Cervantes',
    isbn: '0143105426'
  },
  {
    asin: '0141439518',
    title: 'Pride and Prejudice',
    author: 'Jane Austen',
    isbn: '0141439518'
  },
  {
    asin: '0486284735',
    title: 'Crime and Punishment',
    author: 'Fyodor Dostoevsky',
    isbn: '0486284735'
  },
  {
    asin: '0141439602',
    title: 'Great Expectations',
    author: 'Charles Dickens',
    isbn: '0141439602'
  },
  {
    asin: '0486415872',
    title: 'Moby Dick',
    author: 'Herman Melville',
    isbn: '0486415872'
  },
  {
    asin: '0141439475',
    title: 'Dracula',
    author: 'Bram Stoker',
    isbn: '0141439475'
  },
  {
    asin: '0141439564',
    title: 'Frankenstein',
    author: 'Mary Shelley',
    isbn: '0141439564'
  },
  {
    asin: '0486411095',
    title: 'Sherlock Holmes',
    author: 'Arthur Conan Doyle',
    isbn: '0486411095'
  },
  {
    asin: '0141439688',
    title: 'Jane Eyre',
    author: 'Charlotte Brontë',
    isbn: '0141439688'
  },
  {
    asin: '0141441143',
    title: '1984',
    author: 'George Orwell',
    isbn: '0141441143'
  },
  {
    asin: '0486264645',
    title: 'Dorian Gray',
    author: 'Oscar Wilde',
    isbn: '0486264645'
  },
  {
    asin: '0141439556',
    title: 'Wuthering Heights',
    author: 'Emily Brontë',
    isbn: '0141439556'
  }
];

// Get cover URL - use custom image or Open Library ISBN
const getCoverUrl = (product) => {
  if (product.customImage) {
    return product.customImage;
  }
  return `https://covers.openlibrary.org/b/isbn/${product.isbn}-M.jpg`;
};

function AmazonAd({ type = 'grid', isPremium = false }) {
  const [currentProduct, setCurrentProduct] = useState(null);

  useEffect(() => {
    // Select a random product
    const randomIndex = Math.floor(Math.random() * AMAZON_PRODUCTS.length);
    setCurrentProduct(AMAZON_PRODUCTS[randomIndex]);
  }, []);

  // Don't show ads to premium users
  if (isPremium || !currentProduct) {
    return null;
  }

  const amazonUrl = `https://www.amazon.com/dp/${currentProduct.asin}?tag=${ASSOCIATE_TAG}`;

  const coverUrl = getCoverUrl(currentProduct);

  if (type === 'grid') {
    return (
      <a
        href={amazonUrl}
        target="_blank"
        rel="noopener noreferrer sponsored"
        className="amazonAd amazonAd--grid"
      >
        <div className={`amazonAd__imageContainer ${currentProduct.customImage ? 'amazonAd__imageContainer--product' : ''}`}>
          <img
            src={coverUrl}
            alt={currentProduct.title}
            className="amazonAd__image"
            loading="lazy"
          />
        </div>
        <div className="amazonAd__info">
          <span className="amazonAd__title">{currentProduct.title}</span>
          <span className="amazonAd__author">{currentProduct.author}</span>
          <span className="amazonAd__cta">View on Amazon</span>
        </div>
      </a>
    );
  }

  // Banner type for reader
  if (type === 'banner') {
    return (
      <div className="amazonAd amazonAd--banner">
        <div className="amazonAd__bannerContent">
          <img
            src={coverUrl}
            alt={currentProduct.title}
            className="amazonAd__bannerImage"
          />
          <div className="amazonAd__bannerText">
            <span className="amazonAd__bannerLabel">Sponsored</span>
            <h3 className="amazonAd__bannerTitle">{currentProduct.title}</h3>
            <p className="amazonAd__bannerAuthor">{currentProduct.author}</p>
            <a
              href={amazonUrl}
              target="_blank"
              rel="noopener noreferrer sponsored"
              className="amazonAd__bannerButton"
            >
              Get on Amazon
            </a>
          </div>
        </div>
      </div>
    );
  }

  return null;
}

export default AmazonAd;
